import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/content/discussion',
  owner: '/home',
  authority: 'discussionList',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};